module.exports = __webpack_public_path__ + "static/media/sidebar-logo-icon.f7c9eaf0.svg";